
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent10 as ObiWindApparent10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-10.js';
 
 
 

 
 export const ObiWindApparent10 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-10',
   elementClass: ObiWindApparent10Element,
   events: {
     
   }
  });
 
 